import { Base64 } from 'js-base64';
import JSEncrypt from 'jsencrypt';
function encode(value, key) {
  const encrypt = new JSEncrypt({
    default_key_size: '2048'
  });
  encrypt.setPublicKey(key);
  const val = encrypt.encrypt(value);
  return val;
}
function decode(value) {
  return Base64.decode(value).split('|').map(char => Number.parseInt(char, 10)).reverse().map(charCode => String.fromCharCode(charCode)).join('');
}
export { encode, decode };